import $ from 'jquery';
import 'dotdotdot';

class Ellipsis {
  constructor(elm) {
    $(elm).dotdotdot();
  }
}

export default {
  create(selector) {
    const instances = [];
    const elms = document.querySelectorAll(selector);

    for (let i = 0, j = elms.length; i < j; i += 1) {
      instances.push(new Ellipsis(elms[i]));
    }

    return instances;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Ellipsis.js